import * as React from "react"
import * as styles from "./styles.module.scss"
import cx from "classnames"
import Link from "gatsby-link"
import LinkUnderline from "../../LinkUnderline"
import { useInView } from "react-intersection-observer"

export interface ArticleTileProps {
  className?: string
  imageSrc: string
  imageAlt: string
  excerpt?: string
  metaDescription?: string
  slug: string
  title: string
}

const ArticleTile: React.FC<ArticleTileProps> = ({
  className,
  imageSrc,
  imageAlt,
  excerpt,
  metaDescription,
  slug,
  title,
}) => {
  const [ref, inView, entry] = useInView({ threshold: 0 })

  return (
    <article
      className={cx({
        [styles.articleTile]: true,
        [className]: className,
        [styles.belowViewport]:
          inView && entry && entry.intersectionRect.top > 0,
      })}
      ref={ref}
    >
      <Link className={styles.link} to={slug}>
        {imageSrc && (
          <figure className={styles.figure}>
            <img className={styles.image} src={imageSrc} alt={imageAlt} />
          </figure>
        )}
        <h2 className={styles.heading}>
          <LinkUnderline>{title}</LinkUnderline>
        </h2>
      </Link>
      <div className={styles.excerptWrapper}>
        {metaDescription && (
          <p className={styles.metaDescription}>{metaDescription}</p>
        )}
        {!metaDescription && <p className={styles.excerpt}>{excerpt}</p>}
      </div>
      <Link className={styles.linkReadMore} to={slug}>
        <p className={styles.readMore}>
          <LinkUnderline>Read more</LinkUnderline>
        </p>
      </Link>
    </article>
  )
}

export default ArticleTile
